import { SvgBox, SvgBoxProps } from "@govlaunch/web";
import React from "react";

export default function ProductSymbolIcon(props: SvgBoxProps) {
  return (
    <SvgBox width="40px" height="40px" viewBox="0 0 40 40" fill="none" {...props}>
      <circle cx={20} cy={20} r={18.75} fill="#fff" stroke="#3F4A5A" strokeWidth={2.5} />
      <path d="M19.974 8.345l10.029 5.757-10.095 5.852-10.027-5.756 10.093-5.853z" fill="#fff" />
      <path
        d="M19.909 20.607a.649.649 0 01-.323-.086L9.56 14.764a.652.652 0 01-.003-1.131L19.65 7.78a.647.647 0 01.647-.002l10.028 5.757a.653.653 0 01.003 1.132L20.234 20.52a.65.65 0 01-.325.087zm-8.724-6.412l8.722 5.007 8.792-5.097-8.723-5.007-8.79 5.097z"
        fill="#3F4A5A"
      />
      <path
        d="M20.025 32.308a.652.652 0 01-.65-.646l-.116-11.701a.654.654 0 01.324-.572l10.095-5.852a.646.646 0 01.646-.002c.201.115.326.328.328.56l.117 11.699a.653.653 0 01-.325.571L20.35 32.22a.65.65 0 01-.324.088zm.537-11.979l.101 10.202 8.803-5.105-.102-10.2-8.802 5.103z"
        fill="#3F4A5A"
      />
      <path d="M19.908 19.954l.117 11.701-10.03-5.757-.114-11.7 10.027 5.756z" fill="#fff" />
      <path
        d="M20.031 32.308h-.006a.647.647 0 01-.323-.087L9.673 26.464a.654.654 0 01-.327-.56l-.115-11.7a.652.652 0 01.32-.57c.201-.117.45-.119.652-.003l10.028 5.757c.2.115.325.328.327.56l.116 11.608a.651.651 0 01-.642.752zm-9.39-6.79l8.723 5.006-.102-10.189-8.72-5.006.1 10.188z"
        fill="#3F4A5A"
      />
    </SvgBox>
  );
}
